module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/octopus-star1.a9265604.png";